import { NavSubItem } from './nav-sub-item';

export class IncompleteNavSubItem extends NavSubItem {}
